import React, { useEffect, useRef, useState } from 'react';
import VoiceDemoHero from '../VoiceDemoHero';

// The live phone-agent demo. Lives on the phone agent page; the home page
// links here.
function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') { setInView(true); return undefined; }
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setInView(true); io.disconnect(); } }, { threshold });
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export default function LiveDemoSection() {
  const [demoRef, demoInView] = useInView();
  return (
    <div ref={demoRef}>
    <section id="live-demo" className="py-10 md:py-24 px-4 border-b border-slate-200">
      <div className="container mx-auto max-w-6xl text-center">
        <div className={`transform transition-all duration-1000 ${demoInView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
        <p className="text-blue-600 font-semibold uppercase tracking-[0.28em] text-[10px] md:text-xs mb-2.5 md:mb-5">Try it live</p>
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold tracking-tight leading-[1.1] mb-2.5 md:mb-5">
          Don't take our word for it.{' '}
          <span className="text-blue-600">Talk to the store.</span>
        </h2>
        {/* Mobile drops the simulated phone entirely, so the copy can't
            promise a receipt landing on one. */}
        <p className="md:hidden text-[13px] leading-snug text-slate-600 mb-4 max-w-md mx-auto">
          Our customer care agent recognizes the customer's phone number and pulls up their order. You're Maria. Tap the orb, allow the mic, and ask about your order.
        </p>
        <p className="hidden md:block text-base md:text-lg text-slate-600 leading-relaxed mb-7 md:mb-9 max-w-2xl mx-auto">
          Our customer care agent recognizes the customer's phone number and pulls up their order. In this demo you're Maria, and your receipt is already on the phone. Tap the orb, allow the mic, and ask about your order.
        </p>
        </div>

        <div className={`transform transition-all duration-1000 delay-300 ${demoInView ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 scale-[0.98]'}`}>
          <VoiceDemoHero />
        </div>
      </div>
    </section>
    </div>
  );
}
